import { DashboardListComponent } from './dashboard-list/dashboard-list.component';
import { DashboardForItComponent } from './dashboard-for-it/dashboard-for-it.component';
export var dashboardRoutes = [
    {
        path: 'dashboard',
        component: DashboardListComponent,
        data: {
            'expectedRoles': ['Admin', 'IT', 'Accountant Admin', 'UIH']
        },
    },
    {
        path: 'dashboard-it',
        component: DashboardForItComponent,
        data: {
            'expectedRoles': ['Admin', 'IT', 'UIH']
        },
    },
    {
        path: 'dashboard-admin',
        component: DashboardForItComponent,
        data: {
            'expectedRoles': ['Admin']
        },
    }
];
var DashboardRoutingModule = (function () {
    function DashboardRoutingModule() {
    }
    return DashboardRoutingModule;
}());
export { DashboardRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-routing.module.ts.pre-build-optimizer.js